export enum PaymentStatus {
  InProgress = 'In Progress',
  Success = 'Success',
  Failed = 'Failed',
  Refunded = 'Refunded'
}

export enum PaymentMethod {
  UPI = 'UPI',
  Card = 'Card',
  NetBanking = 'Net Banking'
}

export interface PaymentTransaction {
  orderId: string;
  transactionId: string;
  customerName: string;
  customerEmail: string;
  packageName: string;
  amount: number;
  discountAmount?: number;
  paymentMethod: string;
  status: PaymentStatus;
  date: string;
  currency?: string;
  phoneNumber?: string;
}

export interface PaymentReportSummary {
  totalTransactions: number;
  totalAmount: number;
  successfulPayments: number;
  successAmount: number;
}

export interface PaymentReportRequest {
  searchText?: string;
  packageId?: number;
  status?: PaymentStatus;
  paymentMethod?: PaymentMethod;
  fromDate?: string;
  toDate?: string;
  pageNumber?: number;
  pageSize?: number;
}
